export enum WifiOutletCategory {
    PowderCoating = 'powder-coating',
    Lighting = 'lighting',
    Ventilation = 'ventilation',
    Maintenance = 'maintenance',
    General = 'general',
}
